<div mat-dialog-content>
  @switch (data.dealerCompetitionAction) {
    @case (DealerCompetitionActionType.End) {
      <div>
        <h2>Vil du avslutte konkurransen?</h2>
        <p>
          Det er fortsatt
          <strong>{{ currentDate | dayDiff: data.dealerCompetition.endDate }}</strong>
          igjen av konkurransen. Er du sikker på at du vil avslutte den nå?
        </p>
      </div>
    }

    @case (DealerCompetitionActionType.Delete) {
      <div>
        <h2>Vil du slette konkurransen?</h2>
        <p>All informasjon og detaljer om konkurransen vil bli fjernet og kan ikke gjenopprettes.</p>
      </div>
    }

    @case (DealerCompetitionActionType.DeleteDraft) {
      <div>
        <h2>Vil du slette utkastet?</h2>
        <p>Alle valg du har gjort vil bli slettet.</p>
      </div>
    }
  }
  <div class="dialog-buttons" mat-dialog-actions>
    <app-ice-button class="button" color="outlined" matDialogClose testId="cancel-competition-button" width="100%">
      Avbryt
    </app-ice-button>
    <app-ice-button
      class="button"
      color="secondary"
      testId="confirm-competition-button"
      width="100%"
      (click)="onConfirmCompetitionAction()"
    >
      {{ confirmButtonText }}
    </app-ice-button>
  </div>
</div>
